import { render } from "./CreateEventButton.vue?vue&type=template&id=1cf05f5c"
import script from "./CreateEventButton.vue?vue&type=script&lang=js"
export * from "./CreateEventButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__